import { createFileRoute } from '@tanstack/react-router';
import AvailibilityScheduler from '@/components/shared/availibility-schedule';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/availability'
)({
  component: AvailabilityPage,
});

function AvailabilityPage() {
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>Availability Schedule</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-6">
        <AvailibilityScheduler />
        <div className="flex justify-end gap-4 items-center pt-6 border-t mt-10">
          <button
            type="button"
            onClick={() => window.history.back()}
            className="cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-10 py-2 has-[>svg]:px-3 px-8"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-2 rounded-md transition-colors duration-200"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
